import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const SmartRouting = { id: 7, name: 'Smart Routing' };
export const smartRoutingEnabled = defineFeature({
    type: FeatureType.Boolean,
    propName: 'smart_routing_enabled',
    uiName: 'smartRoutingEnabled',
    displayName: 'Smart Routing Enabled',
    description: 'Enables smart routing agent workflow',
    category: SmartRouting,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
    surfacedIn: ['agent'],
});
export const smartRoutingFeatures = [smartRoutingEnabled];
